// Going this route for now until proper l10n / i18n is put in place.
module.exports = {
  // General
  YES: 'Yes',
  NO: 'No',
  NA: 'N/A',

  // App Component
  PAGE_NOT_FOUND: 'Page not found.',
  STREAM_STARTS_MOMENTARILY: 'The stream should begin momentarily. Thanks for your patience.',
  STREAM_HAS_ENDED: 'The stream has ended. Thank you for attending.',
  THANK_YOU_FOR_YOUR_PATIENCE:
    'It is taking a little longer than expected to load your event. Thank you for your patience.',
  CLOSE: 'Close',
  SHOW_HOVER_TEXT: 'Show',
  HIDE_HOVER_TEXT: 'Hide',
  GO_BACK: 'Go back',
  ENABLE: 'Enable',

  // Access Code
  ACCEPT_TOS: 'Terms of Service',
  ACCEPT_TOS_INSTRUCTIONS:
    'Please read and agree to the terms of service below to view the stream.',
  ENTER_YOUR_ACCESS_CODE: 'Enter Your Access Code',
  ACCESS_CODE_INSTRUCTIONS:
    'Your access code is available on your receipt. You can locate your receipt and access code for this live stream in your email.',
  I_AGREE_TO_TOS: 'I agree to the',
  TOS: 'terms of service',
  START_WATCHING: 'Start watching',
  INVALID_ACCESS_CODE: 'Invalid access code',
  ACCESS_CODE_PRE_GAW: 'This video is not yet available. Please check back after ',
  ACCESS_CODE_POST_GAW: 'This video is no longer available.',
  ACCESS_CODE_PRE_USER_WINDOW: 'This video is not yet available. Please check back again soon.',
  ACCESS_CODE_PRE_USER_WINDOW_WITH_TIME:
    'This video is not yet available. Please check back on {time}.',
  ACCESS_CODE_POST_USER_WINDOW: 'This access code has expired.',
  ACCESS_LOCATION_PROHIBITED: 'Viewing of this stream is prohibited in your area.',

  // Rooms
  ROOM_CREATE_A_ROOM: 'Create a Room',
  ROOM_NAME_YOUR_ROOM: 'Name your room:',
  ROOM_ENTER_ROOM_NAME: 'Enter room name',
  ROOM_ENTER_ROOM_ID: 'Enter room id (e.g. bobs-party-room)',
  ROOM_CREATE_ROOM: 'Create Room',
  ROOM_FAILED_TO_CREATE_ROOM: 'We were unable to create the viewing room.', // todo special case for non unique
  ROOM_CURRENT_ROOM: 'Current room: ',
  ROOM_MAIN_ROOM: 'Main room',
  ROOM_JOIN_ROOM: 'Enter private room code',
  ROOM_JOIN: 'Join',
  ROOM_DOES_NOT_EXIST: 'Room does not exist',
  ROOM_PUBLIC_HEADER: 'Public Rooms',
  ROOM_PRIVATE_HEADER: 'Private Rooms',
  ROOM_COPY_ID_HOVER: 'Copy code to clipboard',
  ROOM_COPY_ID: 'Others can join by entering the room code',
  ROOM_COPY_ID_COMPLETE: 'Copied to clipboard!',

  // Countdown
  STREAM_COUNTDOWN_MOMENTARILY: 'The live stream will begin momentarily...',
  STREAM_WILL_BEGIN_IN: 'The live stream will begin in:',
  VOD_COUNTDOWN_MOMENTARILY: 'The video will be available momentarily...',
  VOD_WILL_BEGIN_IN: 'The video will be available for viewing in:',
  COUNTDOWN_DAYS: 'days',
  COUNTDOWN_HOURS: 'hours',
  COUNTDOWN_MINUTES: 'min',
  COUNTDOWN_SECONDS: 'sec',

  // Event Details
  STREAM_IS_LIVE: 'Live',

  // Player Component
  VOD_HAS_EXPIRED: 'This video is no longer available for viewing.',
  PROBLEM_PLAYING_VIDEO_SOURCE: 'There was a problem connecting the video source.',
  PROBLEM_PLAYING_VIDEO_STABILITY:
    'There was a problem playing your video. Please make sure you are online and your connection is stable.',
  PROBLEM_PLAYING_VIDEO_STABILITY_REFRESH_IF_PERSISTS:
    'It appears that there is a connectivity issue. If you have verified that your connection is stable and this error persists, you may want to refresh this page.',
  UNSUPPORTED_BROWSER: 'Unsupported browser. Must be able to support HLS video.',
  REACHED_ABUSE_LIMIT:
    'This access code has exceeded the maximum amount of concurrent viewers. Please make sure that you are not streaming on multiple devices. Return to watching on those other devices or close those devices to resume the stream here. It may take up to three minutes for the stream to resume.',
  USER_BANNED: 'You have been ejected from the event',
  PLAYER_DELAY_AHEAD_NOTICE: 'Looks like you are ahead of everyone else.',
  PLAYER_DELAY_BEHIND_NOTICE: 'Looks like you are behind everyone else.',
  PLAYER_DELAY_CATCH_UP: 'Catch Up.',

  // External Strem Component
  LAUNCH_EXTERNAL: 'Launch Stream',

  // Chat
  CHAT_TITLE: 'Chat',
  CHAT_PUBLIC_TITLE: 'Public',
  CHAT_NOTHING_NEW: 'Nothing new has been said. Start the conversation.',
  CHAT_TYPE_A_MESSAGE: 'Type a message...',
  CHAT_YOUR_NAME: '',
  CHAT_ENTER_YOUR_FULL_NAME: 'To join chat, please verify your name!',
  CHAT_START_CHATTING: 'Join',
  CHAT_ME: 'Me',
  YOUR_MESSAGE_WAS_REJECTED: 'Your message was rejected.',
  YOUR_MESSAGE_WAS_REJECTED_RATE_LIMIT:
    "You've exceeded the per-minute message limit. Please wait a moment and try again.",
  YOUR_REACTION_WAS_REJECTED_RATE_LIMIT:
    "You've exceeded the per-minute reaction limit. Please wait a moment and try again.",
  CHAT_FAILED_TO_POST_ADMIN_MESSAGE: 'Unable to post your message.',
  CHAT_FAILED_TO_BAN_USER: 'Failed to ban user.',
  CHAT_FAILED_TO_UNBAN_USER: 'Failed to unban user.',
  CHAT_UNABLE_TO_CREATE_MODERATOR_CHAT_SESSION: 'Unable to create the moderator chat session.',
  CHAT_BAN_THIS_USER: 'Ban This User',
  CHAT_BAN_THIS_USER_FROM_EVENT: 'Ban This User From Event',
  CHAT_PIN_MESSAGE: 'Pin Message',
  CHAT_MODERATOR: 'moderator',
  CHAT_EMPTY_MESSAGE: 'You must enter a message.',
  CHAT_CURRENTLY_DISABLED: 'Allow customers to interact by setting up Chat or Reactions',
  CHAT_ENABLE_CHAT: 'Setup Chat and Reactions',
  CHAT_ENABLE_CONFIRM_TITLE: 'Enable Chat?',
  CHAT_ENABLE_CONFIRM_DETAILS: 'Chat will be enabled for all viewers.',
  CHAT_SEEN_AS: 'People will see you as',
  CHAT_NO_NAME_CHANGE: "You won't be able to change your name once you join the chat room.",
  CHAT_CONTINUE_AS: 'Continue as',

  // Chat Moderation
  CHAT_LOADING: 'Loading Chat...',
  CHAT_REACTIONS_ENABLED: 'Reactions enabled.',
  CHAT_NOTHING_SAID: 'Chat enabled. Welcome%name%, you are a moderator.',
  CHAT_BAN_USER_CONFIRM_TITLE: 'Ban User From Chat?',
  CHAT_BAN_USER_CONFIRM_DETAILS:
    'This user will not be able to participate in the livestream chat.',
  CHAT_BAN_USER_FROM_EVENT_CONFIRM_TITLE: 'Ban User From Stream?',
  CHAT_BAN_USER_FROM_EVENT_CONFIRM_DETAILS: 'This user will not be able to watch the stream',
  CHAT_UNBAN_USER_CONFIRM_TITLE: 'Unban User ',
  CHAT_UNBAN_USER_CONFIRM_DETAILS:
    'This user will be able to participate in the livestream chat again.',
  CHAT_UNBAN_USER_BUTTON: 'Enable',
  CHAT_USER_BANNED_TAG: 'Banned',
  CHAT_FEEDBACK_BANNED_FROM_CHAT: 'Banned from Chat',
  CHAT_MODERATION_HEADER: 'Chat',
  USER_MODERATION_HEADER: 'Banned Users',
  CHAT_DELETE_MESSAGE_CONFIRM_TITLE: 'Delete Message?',
  CHAT_DELETE_MESSAGE_CONFIRM_DETAILS:
    'This message will stop being visible to chat users and can not be recovered.',
  CHAT_DELETE_MESSAGE: 'Delete This Message',
  CHAT_DOWNLOAD_HISTORY: 'Download Chat History',
  CHAT_NOTE_MESSAGES_EXPIRE: 'Note: Chat messages expire after 90 days',

  REACTIONS: 'Reactions',

  // Chat Settings
  CHAT_SETTINGS_UPDATE_BUTTON: 'Enable Chat / Save Settings',
  CHAT_SETTINGS_UPDATE_CONFIRM_TITLE: 'Save',
  CHAT_SETTINGS_UPDATE_CONFIRM_DETAILS: 'Enable chat and save settings?',
  CHAT_SETTINGS_DISABLE_CHAT_CONFIRM_TITLE: 'Disable Chat',
  CHAT_SETTINGS_DISABLE_CHAT_CONFIRM_DETAILS:
    'Chat is currently enabled. Do you want to disable chat for this livestream?',
  CHAT_SETTINGS_ALLOW_ROOMS: 'Allow Private Rooms',
  CHAT_SETTINGS_ALLOW_CHAT: 'Allow Chat',
  CHAT_SETTINGS_ALLOW_REACTIONS: 'Allow Reactions',
  CHAT_SETTINGS_MOD_NAME: 'You are a moderator. Enter your name.',
  CHAT_SETTINGS_HEADER: 'Settings',
  CHAT_CONTROLS_HEADER: 'Chat Settings',

  // Embedded iFrame Moderation
  EMBEDDED_FRAMES_ENABLE_BUTTON: 'Show Embedded Content',
  EMBEDDED_FRAMES_ENABLE_CONFIRM_TITLE: 'Show Embedded Content?',
  EMBEDDED_FRAMES_ENABLE_CONFIRM_DETAILS: 'Show embedded content.',
  EMBEDDED_FRAMES_DISABLE_BUTTON: 'Hide Embedded Content',
  EMBEDDED_FRAMES_DISABLE_CONFIRM_TITLE: 'Hide Embedded Content',
  EMBEDDED_FRAMES_DISABLE_CONFIRM_DETAILS: 'Hide embedded content.',

  // Verify Popup Defaults
  VERIFY_POPUP_CONFIRM: 'Confirm',
  VERIFY_POPUP_CANCEL: 'Cancel',

  // Footer
  FOOTER_SUPPORT: 'Support',
  FOOTER_TOS: 'Terms of Service',
  FOOTER_PRIVACY: 'Privacy',

  // Bulletin: Pinned messages from the organizer
  BULLETIN_POSTED_AT: 'Posted at',

  // Analytics
  ANALYTICS_VIEWERSHIP_TITLE: 'Realtime (last 5 min)',
  ANALYTICS_CURRENTLY: 'Currently',
  ANALYTICS_TOTAL_VIEWERS_TITLE: 'Total Unique Viewers',
  ANALYTICS_TOTAL_VIEWERS_FOOTNOTE:
    'Number of unique viewers that have played the stream. Results are about 2 minutes delayed.',
  GEO_METRICS_TITLE: 'Top Locations',
  GEO_COUNTRY_TITLE: 'Country',
  GEO_REGION_TITLE: 'Region',
  GEO_CITY_TITLE: 'City',
  GEO_COUNTRY_DATA_UNAVAILABLE: 'No Country data available',
  GEO_REGION_DATA_UNAVAILABLE: 'No Region data available',
  GEO_CITY_DATA_UNAVAILABLE: 'No City data available',
  ANALYTICS_UNKNOWN_NAME: 'Unknown',

  // Orgainzer: Stream Data
  ORGANIZER_STREAM_ACCESS_CODE_REQUIRED: 'Access Codes Required:',
  ORGANIZER_STREAM_DRM_ENABLED: 'DRM Enabled:',
  ORGANIZER_CHAT_ENABLED: 'Chat Enabled:',
  ORGANIZER_REACTIONS_ENABLED: 'Reactions Enabled:',
  ORGANIZER_STREAM_TYPE: 'Stream Type:',
  ORGANIZER_STREAM_RTMP_URL: 'Stream RTMP URL:',
  ORGANIZER_STREAM_KEY: 'Stream Key:',

  // Organizer: Misc
  ORGANIZER_PRIVATE_ROOMS_ENABLED: 'Private Chat Rooms Enabled:',
  ORGANIZER_LOADING: 'Loading...',
  ORGANIZER_UH_OH:
    'Uh oh. Something looks off. Make sure you have authenticated and that you are in the right place.',
  ORGANIZER_STREAM_PREVIEW: 'Stream Preview',
  ORGANIZER_VIEW_STREAM_LINK: 'View Stream Link',
  ORGANIZER_SEE_PREVIEW: 'Click to see live preview of the incoming stream',
  ORGANIZER_TURN_SOUND_ON: 'Turn sound on',
  ORGANIZER_TURN_SOUND_OFF: 'Turn sound off',
  ORGANIZER_STREAM_INACTIVE: 'Stream is inactive',
  ORGANIZER_STREAM_UNREACHABLE: 'Stream is unreachable',
  ORGANIZER_STREAM_LOADING: 'Stream is loading',
  ORGANIZER_ANALYTICS: 'Analytics',
  ORGANIZER_SETTINGS: 'Stream Settings',

  // Organizer: Download
  ORGANIZER_DOWNLOAD_CREATED_TEXT: 'Created',
  ORGANIZER_DOWNLOAD_STREAM_TEXT: 'Download Recording',
  ORGANIZER_REQUEST_DOWNLOAD_STREAM_TEXT: 'Download',
  ORGANIZER_DOWNLOAD_PREPARING_TEXT: 'Preparing...',
  ORGANIZER_DOWNLOAD_HEADER: 'Download Recordings',
  ORGANIZER_DOWNLOAD_PART_X_OF_Y: 'Part %part% of %total%',
  ORGANIZER_DOWNLOAD_UNKNOWN_ERROR: 'An error happened in the download request, please try again.',
  ORGANIZER_CONVERT: 'Convert',

  // Organizer: Organizer Vod convertion
  ORGANIZER_CONVERT_DURATION: '',
  ORGANIZER_CONVERT_ASSET_X_OF_Y: 'Part %part% of %total%',
  ORGANIZER_CONVERT_TITLE: 'Convert Session to VOD',
  ORGANIZER_CONVERT_DESCRIPTION:
    'This will convert your live broadcast to video. Only convert your broadcast once it hasended. Your broadcast settings will update upon conversion.',
  ORGANIZER_CONVERT_ACCESS: 'Viewer Access',
  ORGANIZER_CONVERT_ACCESS_DESCRIPTION:
    'Customers can watch the recording with their original stream access code.',
  ORGANIZER_CONVERT_START_DATE: 'Available From',
  ORGANIZER_CONVERT_END_DATE: 'Available To',
  ORGANIZER_CONVERT_ASSETS: 'Assets',
  ORGANIZER_CONVERT_NO_ASSETS: 'There are no assets to be converted.',
  ORGANIZER_CONVERT_MULTIPLE_ASSETS:
    'There were multiple video assets recorded. This usually means the stream was started and stopped for this event. You can download, merge these in an external tool, and reupload the entire video manually if you require all parts.',
  ORGANIZER_CONVERT_ASSET_PREVIEW: 'Preview',
  ORGANIZER_CONVERT_BUTTON: 'Convert Now',
  CONVERT_TO_VOD_BUTTON: 'Convert to VOD',
  ORGANIZER_STREAM_ENDED: 'Stream has ended',

  // Event Dashboard: ignore disconnects
  ORGANIZER_IGNORE_DISCONNECTS: 'Ignore Disconnects',
  ORGANIZER_IGNORE_DISCONNECTS_TEXT:
    'If you are having connection issues, this will force the stream broadcast to remain active until you manually end the stream.',
  ORGANIZER_IGNORING_DISCONNECTS: 'Ignoring Disconnects',

  // Event Dashboard: Start streaming early
  ORG_START_STREAMING_NOW: 'Start Streaming Now',
  ORG_START_STREAMING_EARLY: 'Start Streaming Early',
  ORG_SCHEDULED_TO_START: 'Your livestream is scheduled to start',
  ORG_LIKE_TO_START: 'Would you like to start the livestream now?',
  ORG_NOTE_DELAY:
    'Note that there will be a delay of up to 30 seconds before viewers see the stream.',
  ORG_START_STREAM: 'Start Stream',

  // Event Dashboard: End stream
  ORG_END_STREAM_TEXT:
    'End the livestream now? This will end the stream for all viewers within 30 seconds and display the post-stream content.',
  ORG_END_STREAM: 'End Stream',

  // Event Dashboard: Reopen stream
  ORG_REOPEN_STREAM: 'Reopen Stream',

  // Organizer: Subtitles
  CHOOSE_FILE: 'Choose File',
  DELETE_SUBTITLE_QUESTION: 'Delete Subtitle?',
  DELETE_SUBITTLE_CONFIRM: 'Are you sure you want to delete the {lang} subtitle?',
  UNABLE_TO_UPLOAD_SUBTITLE_NO_ASSET:
    'Cannot upload subtitles because there is no video asset for this VOD. Upload your video first.',
  SUBTITLE_PROCESSING_ERROR: 'There was an error processing this subtitle',
  DELETE_THIS_SUBTITLE: 'Delete this subtitle.',
  SUBITTLE_PROVIDES_SDH: 'This file provides Subtitles for the Deaf and Hard-of-Hearing (SDH)',
  SUBTITLES_SUPPORTED: 'SRT and WebVTT file formats are supported',
  NO_SUBTITLES_UPLOADED: 'You have no subtitles uploaded.',
  ADD_SUBTITLE: 'Add Subtitle',
  UPLOAD: 'Upload',
  LANGUAGE: 'Language',
  LANGUAGE_CODE: 'Language Code',
  SUBMIT: 'Submit',

  // Organizer: Activity log
  ACTIVITY_LOG_LINK: 'Activity Log',
  MUX_ACTIVITY_LOG_TITLE: 'Activity Log',
  MUX_OBJECT_TYPE_TITLE: 'Event Type',
  MUX_TYPE_TITLE: 'Status',
  MUX_CREATED_AT_TITLE: 'Created At',

  // Event Dashboard: Alternate URLs tooltip
  CLICK_TO_COPY: 'Click to copy',
  ALT_URLS_TITLE: 'Alternate RTMP URLs',
  ALT_URLS_SECURE:
    'Secure RTMP entry point. This is the preferred entry point but may not be compatible with some older or simpler broadcast software.',
  ALT_URLS_INSECURE:
    'Standard RTMP entry point. Compatible with the majority of streaming applications and services.',
  ALT_URLS_OTHER: 'If neither of those work, try using the URL without the port number, e.g.',

  // Date and Time
  SELECT_DATE_PLACEHOLDER: 'Select Date...',
  SELECT_TIME_PLACEHOLDER: 'Select Time...',

  // Error Bar
  CLEAR: 'Clear', // clear the error message

  // Errors
  FAILED_TO_POST_ADMIN: 'Failed to post admin message',
  FAILED_TO_BAN_USER: 'Failed to ban user from chat',
  FAILED_TO_BAN_USER_ACCESS: 'Failed to ban user access to stream',
  FAILED_TO_RETRIEVE_ANALYTICS: 'Failed to retrieve analytics.',

  // Zoom download copy
  ZOOM_DOWNLOAD_BTN: 'Download Zoom',
  ZOOM_DOWNLOAD_PROMPT:
    'Please be sure you have the latest Zoom Client for Meetings installed first.',
  ZOOM_WARNING_SAFARI:
    "It looks like you're using Safari. If you experience issues launching the stream, please try a different browser.",

  // Event Dashboard geofencing controls
  ORG_GEO_GEOFENCING_TITLE: 'Geofencing',
  ORG_GEO_COUNTRY_TITLE: 'Country',
  ORG_GEO_REGION_TITLE: 'Region',
  ORG_GEO_ADD_COUNTRY_RULE_TITLE: 'Add Country Rule',
  ORG_GEO_ADD_REGION_RULE_TITLE: 'Add Region Rule',
  ORG_GEO_RULE_REMOVE_CONFIRMATION_QUESTION: 'Are you sure you want to remove all rules?',
  ORG_GEO_CONFIGURE_RULES_BUTTON: 'Configure Geofencing Rules',
  ORG_GEO_REMOVE_ALL_RULES_BUTTON: 'Remove Geofencing Rules',
  ORG_GEO_ALLOW_RADIO_LABEL: 'Allow only the following locations',
  ORG_GEO_DENY_RADIO_LABEL: 'Deny only the following locations',
  ORG_GEO_COUNTRY_SELECT_PLACEHOLDER: 'Select or search for countries',
  ORG_GEO_REGION_SELECT_PLACEHOLDER: 'Select or search for regions',
  ORG_GEO_FILTER_BY_COUNTRY: 'Filter by Country',
  ORG_GEO_SELECT_A_COUNTRY: 'Select a country',
  ORG_GEO_ADD_RULE_BUTTON: 'Add Rule',
  ORG_GEO_ADD_SHORT_BUTTON: '+ Add',
  ORG_GEO_RULES_UPDATED_MESSAGE: 'Geofencing rules updated.',
  ORG_GEO_ALLOW_LIST_TITLE: 'Whitelist Access Codes',
  ORG_GEO_ACCESS_CODES: 'Access Codes',
  ORG_GEO_ACCESS_CODES_INFO:
    'Paste a comma-separated list of access codes to allow those ticketholders to view your content regardless of their location.',
  ORG_GEO_COUNTRY_API_REJECTED_FMT: 'You have already set another rule for %country%.',
  ORG_GEO_COUNTRY_COUNTRY_OVERLAP_FMT: 'You have already set a country rule for %country%.',
  ORG_GEO_COUNTRY_REGION_OVERLAP_FMT:
    'Cannot add %country% because you have already selected one or more regions within it. Clear those region selections, then try again.',
  ORG_GEO_REGION_API_REJECTED_FMT:
    'You have already set another rule using the same country (%country%) or region (%region%).',
  ORG_GEO_REGION_COUNTRY_OVERLAP_MESSAGE:
    'You have already set a rule for this country. To specify regions within the country instead, clear the country rule first.',
  ORG_GEO_REGION_REGION_OVERLAP_FMT: 'You have already set a region rule for %region%.',

  // Organizer Dashboard
  ORG_DASH_TITLE: 'Minutes Viewed',
  ORG_DASH_DATEPICKER_LABEL_FROM: 'From',
  ORG_DASH_DATEPICKER_LABEL_TO: 'To',
  ORG_DASH_TOTAL_MIN_VIEWED_TITLE: 'Minutes Viewed',
  ORG_DASH_TOTAL_EVENTS_TITLE: 'Total Events With Views',
  ORG_DASH_EVENT_LIST_TITLE: 'Detail',
  ORG_DASH_EVENT_LIST_STREAM_NAME_COL: 'Virtual Event Name',
  ORG_DASH_EVENT_LIST_MIN_VIEWED_COL: 'Minutes Viewed',
  ORG_DASH_EVENT_LIST_START_DATE_COL: 'Start Date',
  ORG_DASH_EVENT_LIST_EVENT_ID_COL: 'Event ID',
};
